module.exports = __webpack_public_path__ + "img/escudo.b7ffa6ee.svg";